module.exports = __webpack_public_path__ + "img/Cti12PpkRbrSu0002A.83a2c7db.jpg";